import DefaultLayout from '@/views/layouts/Layout'

const Index = () => import('./Index')

export default [
    {
        path: '/organizations/',
        component: DefaultLayout,
        children: [
            {
                path: '',
                redirect: {name: 'organizations.stats.index'},
                name: 'organizations.stats',
            },
            {
                path: 'stats',
                component: Index,
                alias: 'organizations.stats',
                name: 'organizations.stats.index',
            },
            {
                path: 'stats/:id',
                component: Index,
                name: 'organizations.stats.show',
            },
        ]
    },
];
